module.exports = __webpack_public_path__ + "static/img/404.343b846f.png";